import { pipe } from 'fp-ts/lib/function';
import { fromNullable, fold } from 'fp-ts/lib/Option';

const IS_TRIAL = pipe(
  fromNullable(process.env.REACT_APP_ENABLE_SUBSCRIPTION_TRIAL),
  fold(
    () => '',
    (env) => env,
  ),
);

export { IS_TRIAL };
